module.exports = "<app-accountmaster-menu></app-accountmaster-menu>\n<p>\n  new-deposit works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/new-deposit/new-deposit.component.html
// module id = ./src/app/accountmaster/new-deposit/new-deposit.component.html
// module chunks = main